import PropTypes from 'prop-types';
import { InstructorCardProps } from '@prospectus/open-course-page/components/Instructors/components/InstructorCard';

const courseRunShape = {
  start: PropTypes.string,
  end: PropTypes.string,
  enrollmentEnd: PropTypes.string,
  pacingType: PropTypes.string,
  status: PropTypes.string,
  minEffort: PropTypes.number,
  maxEffort: PropTypes.number,
  weeksToComplete: PropTypes.number,
  availability: PropTypes.string,
  staff: PropTypes.arrayOf(PropTypes.shape(
    InstructorCardProps,
    {
      uuid: PropTypes.string,
    },
  )),
  isEnrollable: PropTypes.bool,
};

export default courseRunShape;
